import { common } from '@mui/material/colors';
import BaseAutocomplete from 'common/components/base-autocomplete';
import { colors } from 'common/constants';
import React from 'react';
interface Props {
    name: string;
    options: { label: string; value: string }[];
}
const QuestionDropdown: React.FC<Props> = ({ name, options }) => {
    return (
        <BaseAutocomplete
            placeholder="Vui lòng chọn..."
            name={name}
            isOptionEqualToValue={(option, value) =>
                option.value === value.value
            }
            multiple={false}
            sx={{
                '& .MuiInputBase-root': {
                    height: ['3.5rem', '3.5rem', '4rem', '5rem', '5rem'],
                    fontSize: ['1rem', '1rem', '1.5rem', '1.5rem', '1.7rem'],
                    fontWeight: '400',
                    borderRadius: '10px',
                    backgroundColor: common.white,
                    paddingRight: '1rem !important',
                },
            }}
            disableCloseOnSelect={false}
            options={options}
            ListboxProps={{
                sx: {
                    '& .MuiAutocomplete-option': {
                        fontSize: [
                            '1rem',
                            '1rem',
                            '1.5rem',
                            '1.5rem',
                            '1.7rem',
                        ],
                        fontWeight: 500,
                        '&[aria-selected="true"]': {
                            backgroundColor: 'var(--color-primary-light-20)',
                            color: colors.main,
                        },
                    },
                },
            }}
            blurOnSelect={true}
        />
    );
};

export default QuestionDropdown;
